import React, { useEffect } from "react";
import BlogCard from "../../components/BlogCard/BlogCard";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import { useNavigate } from "react-router-dom";
import { useBlog } from "../../context/BlogContext";
import "./BlogListPage.css";

const BlogListPage = () => {
  const navigate = useNavigate();
  const { posts, loading, error, fetchPosts, pageInfo } = useBlog();

  useEffect(() => {
    document.title = "Blogs | Brandly";
    fetchPosts();
  }, [fetchPosts]);

  const handleReadMore = (slug) => {
    navigate(`/blog/${slug}`);
  };

  const handleLoadMore = () => {
    if (pageInfo?.hasNextPage) {
      fetchPosts(pageInfo.endCursor);
    }
  };

  if (loading && posts.length === 0) {
    return (
      <div className="blog-list-page">
        <Navbar />
        <div className="blog-loading">
          <div className="loading-spinner">Loading blogs...</div>
        </div>
        <Footer />
      </div>
    );
  }

  if (error) {
    return (
      <div className="blog-list-page">
        <Navbar />
        <div className="blog-error">
          <h2>Error loading blogs</h2>
          <p>{error}</p>
          <button onClick={() => fetchPosts()} className="retry-button">
            Try Again
          </button>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="blog-list-page">
      <Navbar />
      <div className="blog-list">
        {posts.map((blog, index) => (
          <div
            key={blog.id || index}
            onClick={() => handleReadMore(blog.slug)}
            style={{ cursor: "pointer" }}
          >
            <BlogCard
              imagePath={blog.coverImage?.url || "https://images.pexels.com/photos/1212056/pexels-photo-1212056.jpeg?auto=compress&cs=tinysrgb&w=1200&lazy=load"}
              date={new Date(blog.publishedAt).toLocaleDateString('en-US', { 
                year: 'numeric', 
                month: 'long', 
                day: 'numeric' 
              })}
              heading={blog.title}
              subtext={blog.brief}
            />
          </div>
        ))}
      </div>
      
      {pageInfo?.hasNextPage && (
        <div className="load-more-container">
          <button 
            onClick={handleLoadMore} 
            disabled={loading}
            className="load-more-button"
          >
            {loading ? "Loading..." : "Load More Posts"}
          </button>
        </div>
      )}
      
      <Footer />
    </div>
  );
};

export default BlogListPage;
